<label class="col-form-label d-block">
  {{ name }}
  <input [type]="type"
         readonly
         [ngClass]="class"
         [style]="style"
         [value]="value"/>
  <ng-content></ng-content>
</label>
